import React, { useEffect, useRef, useState } from "react";
import hljs from "highlight.js";
import { login } from '../utils/api';
import ReactQuill from "react-quill-new";
 import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from "react-router-dom";
import {API_URL} from "../utils/api";
import axios  from "axios";
import { useParams } from "react-router-dom";

const AddContentLayer = () => {
    const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [page, setPage] = useState("");

  const [pageErr, setPageErr] = useState(false);
  const [titleErr, setTitleErr] = useState(false);
   const [contentErr, setContentErr] = useState(false);
   const navigate = useNavigate();
    let { id } = useParams();
    let activeuser =localStorage.getItem('activeUser');
    activeuser =  JSON.parse(activeuser);


  const quillRef = useRef(null);
  const [value, setValue] = useState(``);
   const [isHighlightReady, setIsHighlightReady] = useState(false);

  useEffect(() => {
     hljs?.configure({
      languages: [
        "javascript",
        "ruby",
        "python",
        "java",
        "csharp",
        "cpp",
        "go",
        "php",
        "swift",
      ],
    });
  }, []);
  
  async function fetchContentInfo() {
    axios
      .get(process.env.REACT_APP_API_BASE_URL+"pagecontent-details/" + id)
      .then((res) => {
        // return false;
        if (res.data) {
          console.log("red data", res.data.page);
           setPage(res.data.page);
           setTitle(res.data.title);
           setContent(res.data.content);
           setFormData({id:id, page: res.data.page, title: res.data.title, content: res.data.content});
                   
        } else {
          toast.success("something went wrong...");
        }
      })
      .catch((err) => {
        console.error(err);
        alert(err);
      });
  }

  useEffect(() => {
   if(id){ 
     fetchContentInfo();
     } else{
      setFormData({ ...formData, page: "", title: "", content: "" });
      setPage("");
      setTitle("");
      setContent("");
     }
  }, [id]);
  

  // eslint-disable-next-line no-unused-vars
  const handleSave = () => {
    const editorContent = quillRef.current.getEditor().root.innerHTML;
    console.log("Editor content:", editorContent);
  };

  // Quill editor modules with syntax highlighting (only load if highlight.js is ready)
  const modules = isHighlightReady
    ? {
        syntax: {
          highlight: (text) => hljs?.highlightAuto(text).value, // Enable highlight.js in Quill
        },
        toolbar: {
          container: "#toolbar-container", // Custom toolbar container
        },
      }
    : {
        toolbar: {
          container: "#toolbar-container", // Custom toolbar container
        },
      };

  const formats = [
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "header",
    "blockquote",
    "code-block",
    "list",
    "indent",
    "direction",
    "align",
    "link",
    "image",
    "video",
    "formula",
  ];
  const [formData, setFormData] = useState({
    page: '',
    title: '',
    Content: '',
  });

 
  const handleSubmit = () => {
     if(title != "" && page != "" && content != ""){
    var formData = {
      page : page,
      title : title,
         content : content
    };
    console.log(formData);

     if(id){
        axios.post(process.env.REACT_APP_API_BASE_URL+"pagecontent-update/"+id, { ...formData }/*, {
            headers: {
              "content-type": "multipart/form-data"
            },
            
          }*/)
            .then((res) => {
                console.log(res.data);
                // return false;
              if(res.data.status === true){
                  toast.success('Page Content updated sucessfully!!');
                  setTimeout(() => {
                    navigate('/'+JSON.parse(localStorage.getItem('activeUser')).user_type+'/content-management');
                  }, 2000);
              }
              else{
                  toast.success("something went wrong...")
              }
            })
            .catch(err => {
              console.error(err);
              toast.error(err);
            });
              }else{
                axios.post(process.env.REACT_APP_API_BASE_URL+"pagecontent-add", { ...formData }/*, {
                    headers: {
                      "content-type": "multipart/form-data"
                    },
                    
                  }*/)
                    .then((res) => {
                        console.log(res.data);
                        // return false;
                      if(res.data.status === true){
                          toast.success('Page Content added sucessfully!!');
                          setTimeout(() => {
                            navigate('/'+activeuser.user_type+'/content-management');
                          }, 2000);
                      }
                      else{
                          toast.success("something went wrong...")
                      }
                    })
                    .catch(err => {
                      console.error(err);
                      toast.error(err);
                    });
              }
    

    } else {
     
      if(title == ""){
        setTitleErr(true);
      }
      if(page == ""){
        setPageErr(true);
      }
    
      if(content == ""){
        setContentErr(true);
      }
  
    }
  }


  return (
    <div className='row gy-4'>
      <div className='col-lg-12'>
        <div className='card mt-24'>
          <div className='card-header border-bottom'>
            <h6 className='text-xl mb-0'>{(id)?"Edit":"Add New "} Page Content</h6>
          </div>
          <ToastContainer></ToastContainer>
          <div className='card-body p-24'>
            <form  className='d-flex flex-column gap-20'>

            <div>
                <label className='form-label fw-bold text-neutral-900'>
                Select  Page:{" "}
                </label>
                <select value={page} onChange={(e) =>{
                   setPage(e.target.value)
                   setPageErr(false);
                   if(e.target.value == ""){
                    setPageErr(true);
                   }
                   }} 
                     className={pageErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
              >
                  <option value=''>Select Page</option>
                  <option value='about-us'  {...(page == 'about-us')?'selected=true':""}>About Us</option>
                    </select>
                {pageErr && (
                        <span className="error-message">
                            {'Page is mandatory'}
                        </span>
                    )} 
              </div>
              <div>
                <label
                  className='form-label fw-bold text-neutral-900'
                  htmlFor='title'
                >
                  Post Title:{" "}
                </label>
                <input
                  type='text'
                  className={titleErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
                  id='title'
                  placeholder='Enter Post Title'
                  value={title}
                  onChange={(e) => {
                    setTitle(e.target.value);
                    setTitleErr(false);
                    if(e.target.value == ""){
                      setTitleErr(true);
                    }
                   }}
                />
                 {titleErr && (
                        <span className="error-message">
                            {'Title is mandatory'}
                        </span>
                    )}   
              </div>
              
              <div>
                <label className='form-label fw-bold text-neutral-900'>
                  Post Content
                </label>
                <div className='border border-neutral-200 radius-8 overflow-hidden'>
                  <div className='height-200'>
                    {/* Toolbar */}
                    <div id='toolbar-container'>
                      <span className='ql-formats'>
                        <select className='ql-font'></select>
                        <select className='ql-size'></select>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-bold'></button>
                        <button className='ql-italic'></button>
                        <button className='ql-underline'></button>
                        <button className='ql-strike'></button>
                      </span>
                      <span className='ql-formats'>
                        <select className='ql-color'></select>
                        <select className='ql-background'></select>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-script' value='sub'></button>
                        <button className='ql-script' value='super'></button>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-header' value='1'></button>
                        <button className='ql-header' value='2'></button>
                        <button className='ql-blockquote'></button>
                        <button className='ql-code-block'></button>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-list' value='ordered'></button>
                        <button className='ql-list' value='bullet'></button>
                        <button className='ql-indent' value='-1'></button>
                        <button className='ql-indent' value='+1'></button>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-direction' value='rtl'></button>
                        <select className='ql-align'></select>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-link'></button>
                        <button className='ql-image'></button>
                        <button className='ql-video'></button>
                        <button className='ql-formula'></button>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-clean'></button>
                      </span>
                    </div>

                    {/* Editor */}
                    <ReactQuill
                      ref={quillRef}
                      theme='snow'
                      modules={modules}
                      formats={formats}
                      placeholder='Compose an epic...'
                      value={content}
                      onChange={(e) => {
                        setContent(e);
                    setContentErr(false);
                    if(e == "" || e == "<p><br></p>"  || e == "<p</p>"){
                      setContentErr(true);
                    }
                      }}
                    />
                     {contentErr && (
                        <span className="error-message">
                            {'Content is mandatory'}
                        </span>
                    )}   
                  </div>
                </div>
              </div>
              <button type="button" onClick={() => handleSubmit()} className='btn btn-primary-600 radius-8'>
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
      {/* Sidebar Start */}
    </div>
  );
};

export default AddContentLayer;
